import { defineAsyncComponent } from 'vue'
export default {
  authenticated: defineAsyncComponent(() => import("/codebuild/output/src3693196591/src/and-dine-hub/layouts/authenticated.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src3693196591/src/and-dine-hub/layouts/default.vue").then(m => m.default || m))
}